<template>
  <div class="menu" :class="[{active: isActive}]" ref="menuRef">
    <svg class="menu__close" @click="closeModal" width="25" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 10L1 1M10 1L1 10" stroke="#FF6162" stroke-width="2" stroke-linecap="round"/>
    </svg>
    <div class="menu__actions">
      <nav class="menu__actions-profile" v-if="user">
        <router-link :to="translations.i18nRoute({ name: 'profile-dashboard' })">{{ t('header.burger.dashboard') }}</router-link>
        <router-link :to="translations.i18nRoute({ name: 'profile-orders' })">{{ t('header.burger.orders') }}</router-link>
        <router-link :to="translations.i18nRoute({ name: 'profile-details' })">{{ t('header.burger.accountDetails') }}</router-link>
        <router-link :to="translations.i18nRoute({ name: 'profile-wishlist' })">{{ t('header.burger.wishlist') }}</router-link>
        <router-link :to="translations.i18nRoute({ name: 'profile-cart' })">{{ t('header.burger.cart') }}</router-link>
        <p @click="logout">{{ t('header.burger.logOut') }}</p>
      </nav>
      <div class="menu__actions-auth" v-else>
        <router-link :to="translations.i18nRoute({ name: 'login' })" @click="closeModal">{{ t('header.actions.login') }}</router-link>
        <router-link :to="translations.i18nRoute({ name: 'register' })" @click="closeModal">{{ t('header.actions.register') }}</router-link>
      </div>
      <div class="menu__actions-link" @click="redirect(user ? 'profile-wishlist' : 'login')">
        <div class="menu__actions-counter">
          {{ productsInWishlistQuantity }}
        </div>
        <img src="@icons/wishlistIcon.svg" alt="wishlist">
      </div>
      <div class="menu__actions-link" @click="redirect(user ? 'profile-cart' : 'login')">
        <div class="menu__actions-counter">
          {{ productsInCartQuantity }}
        </div>
        <img src="@icons/cartIcon.svg" alt="cart">
      </div>
    </div>
    <nav class="menu__nav">
      <router-link
          v-for="category of categories"
          :key="category.node.uuid"
          :class="[{active: category.node.name === route.query.category}]"
          :to="translations.i18nRoute({ name: 'store', query: { category: category.node.name } })"
          @click="closeModal"
      >
        {{ category.node.name }}
      </router-link>
<!--      <router-link :to="translations.i18nRoute({ name: 'home' })" @click="closeModal">-->
<!--        Gift Cards-->
<!--      </router-link>-->
<!--      <router-link :to="translations.i18nRoute({ name: 'home' })" @click="closeModal">-->
<!--        Game cards-->
<!--      </router-link>-->
<!--      <router-link :to="translations.i18nRoute({ name: 'about' })" @click="closeModal">-->
<!--        {{ t('header.about') }}-->
<!--      </router-link>-->
<!--      <router-link :to="translations.i18nRoute({ name: 'contact' })" @click="closeModal">-->
<!--        {{ t('header.contact') }}-->
<!--      </router-link>-->
    </nav>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import {computed, ref} from "vue";
import {useAuthStore} from "@/stores/auth.js";
import {useCartStore} from "@/stores/cart.js";
import {useWishlistStore} from "@/stores/wishlist.js";
import {onClickOutside} from "@vueuse/core";
import {useRoute, useRouter} from "vue-router";
import translations from "@/core/helpers/translations.js";

const router = useRouter()
const route = useRoute()
const {t} = useI18n()
const authStore = useAuthStore()
const cartStore = useCartStore()
const wishlistStore = useWishlistStore()

const props = defineProps({
  isActive: Boolean,
  categories: Array,
})
const emit = defineEmits(['close-modal'])

const closeModal = () => {
  emit('close-modal');
}

const menuRef = ref(null)
onClickOutside(menuRef, () => closeModal())

const user = computed(() => {
  return authStore.user
})

const productsInCartQuantity = computed(() => {
  let count = 0
  cartStore.currentOrder.orderProducts?.edges.forEach((el) => {
    count = count + el.node.quantity
  })

  return count
})
const productsInWishlistQuantity = computed(() => {
  return wishlistStore.wishlist.products ? wishlistStore.wishlist.products.edges.length : 0
})

const logout = async () => {
  authStore.setUser({
    user: null,
    accessToken: null
  })

  localStorage.removeItem('ngs-refresh')
  localStorage.removeItem('ngs-remember')
  localStorage.removeItem('ngs-login')

  await router.push({
    name: 'home',
    params: {
      locale: localStorage.getItem('ngs-user-locale') || 'en-gb'
    }
  })
}

const redirect = (routeName) => {
  closeModal()
  router.push({
    name: routeName,
    params: {
      locale: localStorage.getItem('ngs-user-locale') || 'en-gb'
    }
  });
}
</script>

<style lang="scss" scoped>
.menu {
  cursor: default;
  display: none;
  position: fixed;
  z-index: 3;
  top: 0;
  right: 0;
  width: 300px;
  height: 100vh;
  background-color: $white;
  padding: 60px 40px;
  visibility: hidden;
  transform: translateX(100%);
  transition: transform 0.3s, visibility 0s 0.3s;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  border-left: 1px solid #E5E5E5;
  box-shadow: 0 4px 11.6px 0 rgba(0, 0, 0, 0.20);

  &.active {
    visibility: visible;
    transform: translateX(0);
    transition: transform 0.3s;
  }

  &__close {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    &-profile {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;

      & a, p {
        cursor: pointer;
        transition: 0.2s;
        color: #8C8C8C;
        font-size: 16px;
        font-weight: 400;
        line-height: 16px;

        @include hover {
          color: #FF6162;
        }
      }
    }

    &-auth {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 5px;

      & a {
        transition: 0.2s;
        color: #8C8C8C;
        font-size: 16px;
        font-weight: 400;
        line-height: 16px;

        @include hover {
          color: #FF6162;
        }
      }
    }

    &-link {
      width: fit-content;
      cursor: pointer;
      position: relative;
    }

    &-counter {
      position: absolute;
      top: -15px;
      right: -15px;
      border-radius: 50%;
      background-color: #FF6162;
      width: 20px;
      height: 20px;
      display: grid;
      place-items: center;

      color: $white;
      text-align: center;
      font-size: 10px;
      font-weight: 400;
      line-height: 15px;
    }
  }

  &__nav {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;

    & a {
      transition: 0.2s;
      color: #5A5A5A;
      font-size: 16px;
      font-weight: 400;
      line-height: 19.2px;

      &.active {
        color: #FF6162;
      }

      @include hover {
        color: #FF6162;
      }
    }
  }
}

@media (max-width: 1100px) {
  .menu {
    display: flex;
  }
}
</style>